import { AuthContext } from '../../contexts/auth'; 
import { useState, useEffect, useContext } from 'react';
import { useNavigate , useParams, useLocation } from 'react-router-dom';
import { buscarCompartimento, incluirCompartimento, alterarCompartimento, excluirCompartimento, listarFluidos, listarTipoCompartimento } from '../../services/apigateway';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais'; 

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer'; 
import ModalSenha from '../../components/Modal/modalsenha';

export default function CadastroCompartimentos({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);
  const { nomeEquipamento, equipamentoId, compartimentoId } = useParams();
  const [fluidos, setFluidos] = useState([]);
  const [tipos, setTipos] = useState([]);

  const history = useNavigate();
  const location = useLocation();
  const indice = location.state?.indice || '';
  const readOnly = (funcao === 'Consulta' || funcao === 'Exclusão');

  const[tipo, setTipo] = useState('');
  const[fluido, setFluido] = useState('');
  const[capacidade, setCapacidade] = useState('');
  const[situacao, setSituacao] = useState('A');
  const[loading, setLoading] = useState(false);

  const [mostrarModal, setMostrarModal] = useState(false);

  useEffect(()=>{
    if (funcao !== 'Inclusão' && funcao !== 'Consulta' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModal(true);
      // return;
    }

    if (funcao === 'Inclusão') { buscarTipos(); }

    if (funcao === 'Inclusão' || funcao === 'Alteração') { buscarFluidos(); }

    if (funcao !== 'Inclusão') { loadCompartimento(); }
  }, []);

  async function loadCompartimento(){
    setLoading(true);
    
    try {
      const response = await buscarCompartimento(clienteId, equipamentoId, compartimentoId);
      preencheSelecionado(response);
    
    } catch (err) {
      toast.error('Erro ao buscar compartimento');

    } finally {
      setLoading(false);
    }  
  }

  async function buscarTipos() {
    try {
      const response = await listarTipoCompartimento();
      
      setTipos(response); 

    } catch (err) {
      toast.error('Erro ao buscar tipos de compartimento');
    }  
  }

  async function buscarFluidos() {
    try {
      const response = await listarFluidos(clienteId);
      
      setFluidos(response); 

    } catch (err) {
      toast.error('Erro ao buscar fluidos');
    }  
  }

  function handleChangeTipo(e){
    if (e.target.value) { setTipo(e.target.value); }
  } 

  function handleChangeFluido(e){
    if (e.target.value) { setFluido(e.target.value); }
  } 

  function preencheSelecionado(response) {
    setTipo(response[0].tip_compartimento);
    setFluido(response[0].tip_oleo);
    setCapacidade(response[0].cap_compartimento);
    setSituacao(response[0].sit_compartimento);
  }

  function autorizado() { setMostrarModal(false); }

  function naoAutorizado() {
    setMostrarModal(false);
    history('/compartimentos');
  }

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Consulta') {
      history(`/compartimentos/${equipamentoId}`, { state: {indice: indice}});
    }

    if (funcao === 'Alteração' || funcao === 'Inclusão') {
      if (tipo === '' || fluido === '' || capacidade === '' || situacao === '') {
        toast.error('Informe todos os campos obrigatórios');
        return;
      }
    }

    if (funcao === 'Inclusão') {
      //INSERT
      try {
        const response = await incluirCompartimento(clienteId, equipamentoId, 
          { tipo: tipo, fluido: fluido, capacidade: capacidade, situacao: situacao });
      
        if (response === 200) {
          toast.success('Compartimento incluído com sucesso!!');
          history('/compartimentos');
        }

      } catch (err) {
        toast.error('Erro ao incluir compartimento');
      }
    }

    if (funcao === 'Alteração') {
      // UPDATE
      try {
        const response = await alterarCompartimento(clienteId, equipamentoId, compartimentoId, 
          { tipo: tipo, fluido: fluido, capacidade: capacidade, situacao: situacao });
      
        if (response === 200) {
          toast.success('Compartimento alterado com sucesso!!');
          history('/compartimentos');
        }

      } catch (err) {
        toast.error('Erro ao atualizar compartimento');
      }
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        const response = await excluirCompartimento(clienteId, equipamentoId, compartimentoId);
      
        if (response === 200) {
          toast.success('Compartimento excluído com sucesso!!');
          history('/compartimentos');
        }

      } catch (err) {
        toast.error('Erro ao excluir compartimento');
      }
    }

    return;
  }

  function handleSair(e){
   history('/compartimentos');
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Compartimento'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Compartimento...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (mostrarModal) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Compartimentos ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>
            <form method='POST' id='form-geral' className='form-geral'>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Equipamento: {nomeEquipamento}</h3>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Informações do Compartimento</h3>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Tipo</label>
                  {(funcao === 'Inclusão') ? (
                    <div className="single-input">
                        <span>
                          <select className="combo-select" value={tipo} onChange={handleChangeTipo} >
                            <option key='0' value=''>Selecione um Tipo</option>
                            {tipos.map((item, index) => {
                              return(
                                <option key={item.cod_tipcompartimento} value={item.des_tipcompartimento}>
                                  {item.des_tipcompartimento}
                                </option>
                              )
                            })}
                          </select>
                        </span>
                    </div>
                  ):(
                    <div className="single-input">
                      <input 
                        type="text" 
                        id='tipo' 
                        name='tipo' 
                        className='w-full p-2 border border-gray-300 rounded-md' 
                        autoComplete='name' 
                        value={tipo} 
                        onChange={(e) => setTipo(e.target.value)}
                        required 
                        readOnly={true}
                      />                      
                    </div>
                  )}
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Fluido</label>
                  {(funcao === 'Alteração' || funcao === 'Inclusão') ? (
                    <div className="single-input">
                        <span>
                          <select className="combo-select" value={fluido} onChange={handleChangeFluido} >
                            {(funcao === 'Inclusão') ? (
                              <option key='0' value=''>Selecione um Fluido</option>
                            ):(
                              <option key={fluido} value=''>Selecione um Fluido</option>
                            )}
                            {fluidos.map((item, index) => {
                              return(
                                <option key={item.nom_fluido} value={item.nom_fluido}>
                                  {item.nom_fluido}
                                </option>
                              )
                            })}
                          </select>
                        </span>
                    </div>
                  ):(
                    <div className="single-input">
                      <input 
                        type="text" 
                        id='fluido' 
                        name='fluido' 
                        placeholder='Digite o tipo de Fluido' 
                        className='w-full p-2 border border-gray-300 rounded-md' 
                        autoComplete='identificador' 
                        value={fluido} 
                        onChange={(e) => setFluido(e.target.value)}
                        required 
                        readOnly={readOnly}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label>Capacidade</label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='capacidade' 
                      name='capacidade' 
                      placeholder={'Digite a capacidade do compartimento'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='identificador' 
                      value={capacidade} 
                      onChange={(e) => setCapacidade(e.target.value)}
                      required 
                      readOnly={(funcao === 'Consulta' || funcao === 'Exclusão')}
                    />
                  </div>
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'>Situação</h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ativo' 
                        name='ativar' 
                        value='A' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'A'}
                        disabled={readOnly}
                      /> 
                      <label className='mb-0'>Ativo</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='inativo' 
                        name='ativar' 
                        value='I' 
                        onChange={(e) => setSituacao(e.target.value)} 
                        checked={situacao === 'I'}
                        disabled={readOnly}
                      /> 
                      <label>Inativo</label>
                    </div>
                  </div>
                </div>
              </div>

              <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
            </form>
          </section>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
